export interface User {
  id: number;
  name: string;
  email: string;
  birthDate: string;
  cpf: string;
  mobilePhone: string;
  optins: Optins;
  acceptedTermsVersion: number;
  maritalStatus?: MaritalStatus;
  address?: Address;
  sex?: Sex;
}

export interface Optins {
  whatsapp: boolean;
  email: boolean;
  sms: boolean;
  whatsappOrderStatus: boolean;
}

export interface UpdateUserRequest {
  name?: string;
  birthDate?: string;
  mobilePhone?: string;
  optins?: Optins;
  maritalStatus?: MaritalStatus;
  address?: Address;
  sex?: Sex;
}

export interface UpdateUserSignedUrl {
  url: string;
}

export interface Address {
  cep: string;
  street: string;
  addressNumber: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
}

export enum MaritalStatus {
  Empty = 'Empty',
  Single = 'Single',
  Married = 'Married',
  Divorced = 'Divorced',
  Widowed = 'Widowed',
  Separed = 'Separed',
}

export enum Sex {
  Empty = 'Empty',
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}
